import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 15px 15px 15px;

  .note-clickable {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .title {
    font-size: 13px;
    margin-right: 17px;
  }

  .action-box {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .btnControls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 5px;
    min-width: 50px;
    margin-left: 0px;
    margin-right: 8px;
    margin-top: 3px;
    background-color: #f3f3f3;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);
    cursor: pointer;
    padding: 2px;
    padding-right: 10px;

    &:hover {
      background-color: #00aeef;
      .icon-save { color: #FFF; }
      .count { color: #FFF; }
    }

    .icon-save {
      color: #4b4c4b;
      margin-left: 3px;
      margin-right: 3px;
      font-size: 18px;
    }
    .count { font-size: 12px; color: #5e615e; }
  }
`;

export const Title = lib.styled.div`
  font-size: ${fonts.default}px;
  margin-right: 17px;
`;

export const NotesContainer = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  word-break: break-word;
`;

export const RowNotes = lib.styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;

  .message {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    border: 1px solid ${colors.yellow03};
    border-radius: 5px;
    background-color: ${colors.yellow02};

    p {
      font-size: 12px;
      margin: 0px!important;
      padding: 10px;
      white-space: pre-line;
    }
  }

  .informations {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    span {
      font-size: 9px;
      color: ${colors.black};
      opacity: 0.5;
      padding: 5px;
      font-weight: 600;
    }

    .grouped {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-direction: center;

      span:first-child{
        margin-right: 2px;
      }
    }
  }
`;
